module.exports = __webpack_public_path__ + "img/SU2M5.972f7cc4.jpg";